import react from "react";
import Heading from "./Heading";
import Images from './Images';

function Card(props){
    console.log(props);
    return(
     <>
    <div className='col-md-4 my-3'>
    <div className="card">
    <Images imgsrc={props.imgsrc} />
    <div className="card-body">
      <Heading title={props.title}/>
      <p className="card-text">{props.text}</p>
      <a href={props.link} className="btn btn-primary">Go Somewhere</a>
    </div>
  </div>
  </div>
     </>
    )
  }

  export default Card;